export enum TiposPdf {
  APOLICE = "APOLICE",
  PROPOSTA = "PROPOSTA",
}
